import moment from "moment";
import OrderService from "../orders/order";
import { IOrderResourceShortProps } from "../../props/orders/order";

export type EmployeePerformanceProps = {
    totalRevenue: number;
    totalProfit: number;
    profitPercentage: number;
    totalCompanies: number;
}

export default class EmployeePerformanceService {
    private userId: string;

    public constructor(userId: string) {
        this.userId = userId;
    }

    public monthly = async (date: string, basedOn: string): Promise<{currentMonth: EmployeePerformanceProps, previousMonth: EmployeePerformanceProps}> => {
        const recapRes = await this.recap(date, basedOn, 'month');
        return {
            currentMonth: recapRes.currentPeriod,
            previousMonth: recapRes.previousPeriod
        };
    }

    public recap = async (date: string, basedOn: string, period: 'month' | 'year' = 'month'): Promise<{currentPeriod: EmployeePerformanceProps, previousPeriod: EmployeePerformanceProps}> => {
        const isYearly = period === 'year';
        const unit = isYearly ? 'year' : 'month';

        const currentStart = moment(date).startOf(unit).toISOString();
        const currentEnd = moment(date).endOf(unit).toISOString();

        const previousStart = moment(currentStart).add(-1, unit).startOf(unit).toISOString();
        const previousEnd = moment(currentEnd).add(-1, unit).endOf(unit).toISOString();

        let basedOnFilter = '';
        if (basedOn === 'loading date') {
            basedOnFilter = 'actual_departure_';
        }

        const currentOrdersRequest = OrderService.retrieve([`top=all`, `sales=${this.userId}`, `start_${basedOnFilter}date=${currentStart}`, `end_${basedOnFilter}date=${currentEnd}`].join("&"));
        const previousOrdersRequest = OrderService.retrieve([`top=all`, `sales=${this.userId}`, `start_${basedOnFilter}date=${previousStart}`, `end_${basedOnFilter}date=${previousEnd}`].join("&"));

        const [currentOrders, previousOrders] = await Promise.all([currentOrdersRequest, previousOrdersRequest]);
        
        return {
            currentPeriod: this.calculate(currentOrders.data),
            previousPeriod: this.calculate(previousOrders.data)
        };
    }

    private calculate = (orders: IOrderResourceShortProps[]): EmployeePerformanceProps => {
        let totalRevenue: number = 0;
        let totalProfit: number = 0;
        let companiesId: string[] = [];

        (orders || []).forEach((order) => {
            const salesCount = (order.sales && order.sales.length > 0) ? order.sales.length : 1;
            const shareRatio = 1 / salesCount;

            totalRevenue += Number(order.totalAmount || 0) * shareRatio;
            totalProfit += Number(order.nettProfit || 0) * shareRatio;
            if (order.company && companiesId.indexOf(order.company.id) < 0) {
                companiesId.push(order.company.id);
            }
        });

        return {
            totalRevenue,
            totalProfit,
            profitPercentage: totalRevenue > 0 ? (totalProfit / totalRevenue) * 100 : 0,
            totalCompanies: companiesId.length
        }
    }
}